import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function ReviewQR() {
  const [url, setUrl] = useState("");

  useEffect(() => {
    api.get("/settings").then(({ data }) => setUrl(data?.links?.google_review_url || ""));
  }, []);

  return (
    <div className="min-h-screen bg-[#0C0C0C] print:bg-white flex flex-col items-center py-8 print:py-0">
      <style>{`@page{size:A4 portrait;margin:0}@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}`}</style>
      <div className="flex gap-3 mb-6 print:hidden">
        <Link to="/admin" className="inline-flex items-center gap-2 rounded-full border border-[#444] text-white font-display font-bold uppercase px-5 py-2.5" data-testid="qr-back">
          <ArrowLeft size={16} /> Admin
        </Link>
        <button onClick={() => window.print()} disabled={!url} className="inline-flex items-center gap-2 rounded-full bg-[#FFC20E] text-[#0C0C0C] font-display font-extrabold uppercase px-5 py-2.5 disabled:opacity-50" data-testid="qr-print-button">
          <Printer size={16} /> Stampa
        </button>
      </div>

      <div className="w-[210mm] max-w-full aspect-[210/297] bg-[#FFC20E] grain flex flex-col items-center justify-between text-center overflow-hidden print:w-[210mm] print:h-[297mm]" data-testid="qr-sheet">
        <div className="w-full bg-[#0C0C0C] py-8 flex justify-center">
          <img src="/assets/10_logo_ungrip_header.png" alt="UNGRIP" className="h-24 sm:h-32" />
        </div>
        <div className="px-8 sm:px-14">
          <h1 className="font-display font-black uppercase display-tight text-5xl sm:text-7xl text-[#0C0C0C]">
            TI HA PRESO UNGRIP?<br />LASCIA IL SEGNO.
          </h1>
          <p className="font-semibold text-lg sm:text-2xl text-[#0C0C0C] mt-4">Se il morso ti è rimasto in testa, faccelo sapere.</p>
        </div>
        <div className="bg-white p-5 rounded-2xl border-4 border-[#0C0C0C]" data-testid="qr-code">
          {url ? <QRCodeSVG value={url} size={260} level="M" fgColor="#0C0C0C" /> : <div className="w-[260px] h-[260px]" />}
        </div>
        <div className="pb-10">
          <p className="font-hand text-3xl sm:text-4xl font-bold text-[#0C0C0C] -rotate-2">inquadra e recensisci</p>
          <p className="font-display font-black uppercase tracking-[0.3em] text-sm text-[#0C0C0C]/70 mt-3">RECENSISCI SU GOOGLE</p>
        </div>
      </div>
    </div>
  );
}
